import { formatSmallNumber } from './formatSmallNumber';

export function formatDollarAmount(
  amount = 0,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
  sufix = '',
  ignoreSmallValue
) {
  if (!ignoreSmallValue && Math.abs(amount) < 0.01 && Math.abs(amount) !== 0) {
    return `${formatSmallNumber(Number(amount))}${sufix ? sufix : ' USDT'}`;
  }

  const formattedAmount = amount?.toLocaleString('en-US', {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  return formattedAmount + (sufix ? (sufix === ' ' ? '' : sufix) : ' USDT');
}

export const formatValue = (
  value,
  minimumFractionDigits = 1,
  maximumFractionDigits = 1
) => {
  const formatter = new Intl.NumberFormat('en-US', {
    notation: 'standard',
    compactDisplay: 'long',
    currency: 'USD',
    minimumFractionDigits,
    maximumFractionDigits,
  });

  return formatter.format(value);
};

export const formatValueWithoutRounding = (
  value,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2
) => {
  const factor = Math.pow(10, maximumFractionDigits);
  const truncatedValue = Math.floor(value * factor) / factor;

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  return formatter.format(truncatedValue);
};
